// How many skeleton rows the admin careers list should draw on a cold load.
// Global cache — one list for the whole product. See
// docs/skeleton_count_caching.md.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const KEY = 'admin_career_jobs_count'
const DEFAULT_COUNT = 5

export function getCachedCareerJobsCount() {
  return getCachedSkeletonCount(KEY, DEFAULT_COUNT)
}

export function setCachedCareerJobsCount(count) {
  setCachedSkeletonCount(KEY, count)
}
